import { OpsEventKind } from 'types/operationsControl.interface'
import { SOURCE_META } from 'pages/Operations/Shared/opsControl'
import { OPS_DEPARTMENTS, opsDepartments } from 'pages/Operations/Shared/opsDepartments'
import {
  ITimelineDepartmentFilterOption,
  ITimelineSeverityFilterOption,
  ITimelineSourceFilterOption,
  ITimelineTimeFilterOption,
} from 'types/opsTimeline.interface'

export const DEPARTMENT_LABEL: { [k: string]: string } = OPS_DEPARTMENTS.reduce(
  (acc: { [k: string]: string }, d) => ({ ...acc, [d.key]: d.name }),
  {},
)

export const KIND_LABEL: { [k in OpsEventKind]: string } = {
  'shift_start': 'SHIFT',
  'shift_program_run': 'PROGRAM RUN',
  'task_generated': 'GENERATED',
  'task_started': 'STARTED',
  'task_completed': 'COMPLETED',
  'task_blocked': 'BLOCKED',
  'trigger_fired': 'TRIGGER',
  'alert_raised': 'ALERT',
  'machine_down': 'MACHINE',
  'machine_up': 'MACHINE',
  'booking_created': 'BOOKING',
  'plan_progress': 'PLAN',
  'incident': 'INCIDENT',
  'request': 'REQUEST',
}

export const GROUP_KIND_PHRASE: { [k in OpsEventKind]?: string } = {
  'task_generated': 'work orders created',
  'task_started': 'tasks started',
  'task_completed': 'tasks completed',
  'alert_raised': 'alerts raised',
}

export const DEPARTMENT_FILTERS: ITimelineDepartmentFilterOption[] = [
  { key: 'ALL', label: 'All' },
  ...opsDepartments().map((d) => ({ key: d.key, label: d.name })),
]

export const SEVERITY_FILTERS: ITimelineSeverityFilterOption[] = [
  { key: 'ALL', label: 'All' },
  { key: 'critical', label: 'Critical' },
  { key: 'warning', label: 'Warning' },
  { key: 'info', label: 'Info' },
]

export const SOURCE_FILTERS: ITimelineSourceFilterOption[] = [
  { key: 'ALL', label: 'All' },
  { key: 'PLAN', label: SOURCE_META.PLAN.label },
  { key: 'SHIFT_PROGRAM', label: SOURCE_META.SHIFT_PROGRAM.label },
  { key: 'TRIGGER', label: SOURCE_META.TRIGGER.label },
  { key: 'MANUAL', label: SOURCE_META.MANUAL.label },
  { key: 'REQUEST', label: SOURCE_META.REQUEST.label },
]

export const TIME_FILTERS: ITimelineTimeFilterOption[] = [
  { key: 'ALL', label: 'All' },
  { key: 'H06', label: '06–07' },
  { key: 'H07', label: '07–08' },
  { key: 'SINCE_07', label: 'Since 07:00' },
]

export const matchesTimeFilter = (key: ITimelineTimeFilterOption['key'], time: string): boolean => {
  if (key === 'ALL') return true
  const hour = Number(time.split(':')[0])
  if (key === 'H06') return hour === 6
  if (key === 'H07') return hour === 7
  return hour >= 7
}
